import { z } from 'zod';
export const planningSettingsSchema = z.object({
    weeklyCapacityMinutes: z.number().int().positive(),
    weeklyBillableTargetMinutes: z.number().int().nonnegative(),
    roundingMinutes: z.number().int().min(1).max(60),
    overloadCriticalBasisPoints: z.number().int().min(1),
    billableAtRiskBasisPoints: z.number().int().min(0).max(10_000),
    billableCriticalBasisPoints: z.number().int().min(0).max(10_000),
    delayAtRiskBusinessDays: z.number().int().min(0),
    delayCriticalBusinessDays: z.number().int().min(0),
    budgetAtRiskBasisPoints: z.number().int().min(0),
    budgetCriticalBasisPoints: z.number().int().min(0),
    sprintAnchorDate: z.iso.date(),
    sprintLengthWeeks: z.number().int().min(1).max(6),
    inactivityThresholdDays: z.number().int().min(1).max(3650),
});
//# sourceMappingURL=planning.js.map